import { render, staticRenderFns } from "./OrganisationRating.vue?vue&type=template&id=5ee28b0e&scoped=true"
import script from "./OrganisationRating.vue?vue&type=script&lang=ts"
export * from "./OrganisationRating.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationRating.vue?vue&type=style&index=0&id=5ee28b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee28b0e",
  null
  
)

export default component.exports